<template>
  <div class="login-container">
    <div id="canvas-container"></div>
    <div :style="{'visibility': !showLogin ? 'hidden' : 'visible'}">
      <el-form
        autoComplete="on"
        :model="loginForm"
        :rules="loginRules"
        ref="loginForm"
        label-position="left"
        label-width="0px"
        class="card-box login-form"
      >
        <h3 class="title">共享单车监管平台</h3>
        <el-form-item prop="email">
          <el-input
            name="usernameOrPhone"
            type="text"
            v-model="loginForm.usernameOrPhone"
            autoComplete="on"
            placeholder="用户名"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            name="password"
            type="password"
            @keyup.enter.native="handleLogin"
            v-model="loginForm.password"
            autoComplete="on"
            placeholder="密码"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            style="width: 100%;background-color: #00DADA;border-color: #3e7878;"
            :loading="loading"
            @click.native.prevent="handleLogin"
          >
            登录
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div
      v-if="!showLogin"
      v-loading="!showLogin"
      element-loading-text="登录中..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      style="height:100%;">
    </div>
    <div class="copyright" @click="toWeb">
      Copyright © 2020 gxdcjg.com 浙ICP备19047427号-2
    </div>
  </div>
</template>

<script>
import Api from '../../api'
import store from '../../store'

export default {
  name: 'login',
  data() {
    const validateEmail = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入用户名'))
      } else {
        callback()
      }
    }
    const validatePass = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error('密码不能小于6位'))
      } else {
        callback()
      }
    }
    return {
      loginForm: {
        usernameOrPhone: '',
        password: ''
      },
      loginRules: {
        usernameOrPhone: [
          { required: true, trigger: 'blur', validator: validateEmail }
        ],
        password: [
          { required: true, trigger: 'blur', validator: validatePass }
        ]
      },
      loading: false,
      showDialog: false,
      showLogin: true
    }
  },
  methods: {
    autoLogin() {
      // 线上访问地址：https://www.gxdcjg.com/#/login?username=111&password=222
      // 测试访问地址：https://test1.gxdcjg.cn/gxdc/#/login?username=111&password=222
      const params = this.getAllUrlParam()
      this.loginForm.usernameOrPhone = params.username
      this.loginForm.password = params.password
      this.handleLogin()
    },
    getAllUrlParam(url) {
      url = !url ? window.location.href : url
      url = url.indexOf('?') > -1 ? url.substring(url.indexOf('?') + 1, url.length) : ''
      var result = {}
      if (url) {
        const list = url.toString().split('&')
        for (const obj of list) {
          result[obj.split('=')[0]] = obj.split('=')[1]
        }
      }
      return result
    },
    toWeb() {
      window.open('https://beian.miit.gov.cn/')
    },
    handleLogin() {
      const vm = this
      vm.$refs.loginForm.validate((valid) => {
        if (valid) {
          vm.loading = true
          Api.login(vm.loginForm)
            .then((res) => {
              if (res.code === 200 && res.data.token) {
                const selfAreaId = res.data.areaId
                store.commit('globalVariable/setAreaId', selfAreaId)
                const authorizationParams = {
                  key: 'authorization',
                  value: `${res.data.tokenType} ${res.data.token}`
                }
                store
                  .dispatch('user/login', authorizationParams)
                  .then((res) => {
                    const params = {
                      selfAreaId
                    }
                    store
                      .dispatch('user/getInfoByLogin', params)
                      .then((response) => {
                        const areaId =
                          response && response.data && response.data.areaId
                        let url = '/index/'
                        // if (response.data.areaLevel < 2) {
                        //    url = "/dailyDuty/";
                        // } else {
                        //    url = "/index/";
                        // }
                        if (areaId) {
                          url += areaId
                        }
                        console.log(url, 111222)
                        vm.$router.push(url)
                      })
                  })
              } else {
                vm.initShowLogin()
                vm.$message.error(res.message)
              }
              vm.loading = false
            })
            .catch((err) => {
              vm.initShowLogin()
              console.log('the login has problem! ', err)
            })
        } else {
          console.log('error submit!!')
          vm.initShowLogin()
          return false
        }
      })
    },
    initShowLogin() {
      if (!this.showLogin) {
        this.showLogin = true
        this.$router.push('/login')
        // this.loginForm.usernameOrPhone = ''
        // this.loginForm.password = ''
      }
    }
  },
  mounted() {
    // let getRequestAnimId = bgAnimation();
    // this.$on("hook:destroyed", () =>
    //   window.cancelAnimationFrame(getRequestAnimId())
    // );
    if (location.href.indexOf('username=') > -1 && location.href.indexOf('password=') > -1) {
      this.showLogin = false
      this.autoLogin()
    }
  },
  created() {
    if (this.$store.state.user.needReload) {
      window.location.reload()
    }
  },
  components: {}
}
</script>

<style rel="stylesheet/scss" lang="less">
.copyright {
  color: #fff;
  font-size: 16px;
  position: absolute;
  bottom: 30px;
  left: 0;
  text-align: center;
  cursor: pointer;
  width: 100%;
  z-index: 10;
}
.tips {
  font-size: 14px;
  color: #fff;
  margin-bottom: 5px;
}

.login-container {
  position: relative;
  width: 100%;
  height: 100%;
  height: 100vh;
  background-color: #2d3a4b;
  input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 1000px #293444 inset !important;
    -webkit-text-fill-color: #fff !important;
  }
  input {
    background: transparent;
    border: 0px;
    -webkit-appearance: none;
    border-radius: 0px;
    padding: 12px 5px 12px 15px;
    color: #eeeeee;
    height: 47px;
  }
  .el-input {
    display: inline-block;
    height: 47px;
    width: 85%;
  }
  .svg-container {
    padding: 6px 5px 6px 15px;
    color: #889aa4;
  }
  .title {
    font-size: 26px;
    font-weight: 400;
    color: #eeeeee;
    margin: 0px auto 40px auto;
    text-align: center;
    font-weight: bold;
  }
  .login-form {
    position: absolute;
    left: 0;
    right: 0;
    width: 400px;
    padding: 35px 35px 15px 35px;
    margin: 120px auto;
    z-index: 2;
  }
  .el-form-item {
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    color: #454545;
  }
  .forget-pwd {
    color: #fff;
  }
}
#canvas-container {
  position: absolute;
  z-index: 1;
}
</style>
